import { LeadCardHistory } from 'modules/lead';

 
const ObjectCardEvents = ({vobjectFull}) => { 
     
    return (<div className="px-3">
        <LeadCardHistory
            showLockButton={false}
            lead={vobjectFull?.lead} 
            events={vobjectFull?.events}/>      
    </div>)
}

export default ObjectCardEvents;